import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const updateClientServiceSubscriptionTaskChecklistItemCheck = (
  checklistItemId,
  isChecked
) => {
  return new Promise(async (resolve) => {
    try {
      const token = Cookies.get("Bearer");
      const response = await axios.put(
        `${FIRMFLOWURL}api/ClientServiceSubscriptionTaskChecklistItem/UpdateCheck/${checklistItemId}?isChecked=${isChecked}`,
        {},
        {
          headers: { Authorization: token },
        }
      );
      console.log("respuesta: ", response);
      resolve({ ...response, success: true });
    } catch (err) {
      console.log(
        "error on getClientServiceSubscriptionTaskChecklistItem",
        err
      );
      if (err.message.includes(401)) {
        Cookies.remove("Bearer");
        window.location.replace("/");
        return;
      }
      resolve({ success: false, message: err.message });
    }
  });
};
